import type { IconProps } from './types/types';

const FreshdeskIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.9687 1.99959H19.48C19.8119 1.99692 20.1411 2.06038 20.4482 2.18625C20.7553 2.31212 21.0343 2.4979 21.2689 2.73273C21.5034 2.96757 21.6889 3.24676 21.8144 3.55404C21.9399 3.86131 22.0031 4.1905 22 4.5224V12.0309C22 17.5377 17.5381 21.9996 12.0312 21.9996H11.9744C10.6649 22.0007 9.36806 21.7438 8.15794 21.2435C6.94782 20.7432 5.84817 20.0092 4.92184 19.0837C3.99552 18.1582 3.26068 17.0592 2.75934 15.8494C2.25799 14.6397 1.99996 13.3431 2 12.0337C2 6.51115 6.45437 2.05647 11.9687 1.99959Z"
      fill="#25C16F"
    />
    <path
      d="M11.9687 6.4541C9.43969 6.4541 7.3894 8.5041 7.3894 11.0335V14.1472C7.40753 14.9807 8.07878 15.6519 8.91219 15.67H10.2075V12.0932H8.4575V11.0932C8.56375 9.21004 10.1222 7.73691 12.0087 7.73691C13.8953 7.73691 15.45 9.20723 15.5562 11.0932V12.0932H13.7812V15.6725H14.9516V15.7294C14.9391 16.5025 14.3156 17.1263 13.5453 17.1357H12.1475C12.0337 17.1357 11.9087 17.1925 11.9087 17.306C11.9115 17.3684 11.9376 17.4275 11.9817 17.4717C12.0259 17.5159 12.0851 17.542 12.1475 17.5447H13.5537C14.5553 17.5385 15.3656 16.7282 15.3719 15.7266V15.6129C15.7064 15.5375 16.0051 15.3498 16.218 15.081C16.4309 14.8122 16.5454 14.4786 16.5422 14.1357V11.0932C16.5991 8.51379 14.5534 6.45691 11.9628 6.45691L11.9687 6.4541Z"
      fill="white"
    />
  </svg>
);

export default FreshdeskIcon;
